module.exports = __webpack_public_path__ + "img/ic_services_bar.3bd09ca3.svg";